"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const react_1 = __importStar(require("react"));
const ethers_1 = require("ethers");
const types_1 = require("../../modules/authorization/types");
const utils_1 = require("../../modules/authorization/utils");
const eth_1 = require("../../lib/eth");
const selectors_1 = require("../../modules/wallet/selectors");
const actions_1 = require("../../modules/authorization/actions");
const AuthorizationModal_1 = require("./AuthorizationModal");
const mapState = (state) => ({
    address: (0, selectors_1.getAddress)(state)
});
const mapDispatch = (dispatch) => ({
    onClearAuthorizationFlow: () => dispatch((0, actions_1.authorizationFlowClear)())
});
function withAuthorizedAction(WrappedComponent, action, translationKeys, getConfirmationStatus, getConfirmationError) {
    // TODO: Remove any type
    const WithAutorizedActionComponent = (props) => {
        const [showAuthorizationModal, setShowAuthorizationModal] = (0, react_1.useState)(false);
        const [authModalData, setAuthModalData] = (0, react_1.useState)();
        const [isLoadingAuthorization, setIsLoadingAuthorization] = (0, react_1.useState)(false);
        const { address, onClearAuthorizationFlow } = props;
        const handleAuthorizedAction = (0, react_1.useCallback)((authorizeOptions) => __awaiter(this, void 0, void 0, function* () {
            if (!address) {
                return;
            }
            setIsLoadingAuthorization(true);
            const { authorizationType, targetContract, authorizedAddress, targetContractName, authorizedContractLabel, onAuthorized } = authorizeOptions;
            const networkProvider = yield (0, eth_1.getNetworkProvider)(targetContract.chainId);
            const provider = new ethers_1.ethers.providers.Web3Provider(networkProvider);
            const authorization = {
                type: authorizationType,
                address,
                authorizedAddress,
                contractAddress: targetContract.address,
                chainId: targetContract.chainId,
                contractName: targetContractName
            };
            try {
                if (authorizationType === types_1.AuthorizationType.ALLOWANCE) {
                    const { requiredAllowanceInWei } = authorizeOptions;
                    if (ethers_1.BigNumber.from(requiredAllowanceInWei).isZero()) {
                        onAuthorized(true);
                        setIsLoadingAuthorization(false);
                        return;
                    }
                    const contract = (0, utils_1.getERC20ContractInstance)(targetContract.address, provider);
                    const allowance = yield contract.allowance(address, authorizedAddress);
                    if (allowance.gte(ethers_1.BigNumber.from(requiredAllowanceInWei))) {
                        onAuthorized(true);
                        setIsLoadingAuthorization(false);
                        return;
                    }
                    setAuthModalData({
                        translationKeys,
                        authorization,
                        authorizedContractLabel,
                        currentAllowance: allowance,
                        requiredAllowance: ethers_1.BigNumber.from(requiredAllowanceInWei),
                        authorizationType: authorizationType,
                        action,
                        network: targetContract.network,
                        onAuthorized: () => onAuthorized(false),
                        getConfirmationStatus,
                        getConfirmationError
                    });
                }
                else {
                    const contract = (0, utils_1.getERC721ContractInstance)(targetContract.address, provider);
                    const isApprovedForAll = yield contract.isApprovedForAll(address, authorizedAddress);
                    if (isApprovedForAll) {
                        onAuthorized(true);
                        setIsLoadingAuthorization(false);
                        return;
                    }
                    const { targetContractLabel } = authorizeOptions;
                    setAuthModalData({
                        translationKeys,
                        authorization,
                        authorizationType: authorizationType,
                        action,
                        network: targetContract.network,
                        authorizedContractLabel,
                        targetContractLabel,
                        onAuthorized: () => onAuthorized(false),
                        getConfirmationStatus,
                        getConfirmationError
                    });
                }
                setShowAuthorizationModal(true);
            }
            catch (error) {
                // TODO: handle error scenario
                console.error(error);
            }
        }), [address]);
        const handleClose = (0, react_1.useCallback)(() => {
            setIsLoadingAuthorization(false);
            setShowAuthorizationModal(false);
            onClearAuthorizationFlow();
        }, []);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(WrappedComponent, Object.assign({}, props, { onAuthorizedAction: handleAuthorizedAction, onCloseAuthorization: handleClose, isLoadingAuthorization: isLoadingAuthorization })),
            showAuthorizationModal && authModalData ? (react_1.default.createElement(AuthorizationModal_1.AuthorizationModal, Object.assign({ onClose: handleClose }, authModalData))) : null));
    };
    return (0, react_redux_1.connect)(mapState, mapDispatch)(WithAutorizedActionComponent);
}
exports.default = withAuthorizedAction;
//# sourceMappingURL=withAuthorizedAction.js.map